const ONE_DAY_MS = 24 * 60 * 60 * 1000;

// A draft counts as "empty" when every string/array in it (recursively) is
// empty — i.e. nothing has actually been entered or arranged yet. Task
// components' load-on-mount effect and save-on-change effect both run on the
// very first render, before the task's real content has finished populating
// state, so without this guard the save effect can persist a blank snapshot
// (e.g. { categoryObjects: [], draggableItems: [] }) that then permanently
// overrides the real content on every later load, for up to 24h.
function isEmptyDraft(value: unknown): boolean {
    if (value == null) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.every(isEmptyDraft);
    if (typeof value === 'object') return Object.values(value).every(isEmptyDraft);
    return false;
}

export function saveHomeworkState(taskId: number, data: unknown): void {
    if (isEmptyDraft(data)) return;
    localStorage.setItem(`homework_${taskId}`, JSON.stringify({ data, savedAt: Date.now() }));
}

export function loadHomeworkState(taskId: number): unknown | null {
    const raw = localStorage.getItem(`homework_${taskId}`);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (!parsed.savedAt || Date.now() - parsed.savedAt > ONE_DAY_MS || isEmptyDraft(parsed.data)) {
            localStorage.removeItem(`homework_${taskId}`);
            return null;
        }
        return parsed.data;
    } catch {
        localStorage.removeItem(`homework_${taskId}`);
        return null;
    }
}

export function clearHomeworkState(taskId: number): void {
    localStorage.removeItem(`homework_${taskId}`);
}
